import { Component, Inject, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { MasterService } from "@frontend/app/serivces/master.service";
import { Cls_EventData } from "@frontend/app/models/master";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AsteriskMessageDirective } from "@frontend/app/directives/asterikmessage.directive";

@Component({
  selector: "app-add-event",
  imports: [CommonModule, SharedModule, AsteriskMessageDirective],
  templateUrl: "./add-event.component.html",
  styleUrl: "./add-event.component.scss",
})
export class AddEventComponent implements OnInit {
  private masterService = inject(MasterService);
  private toastrService = inject(ToastrService);
  private toastService = inject(ToastrService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AddEventComponent>) {}

  ngOnInit() {
    if (this.data.eventId) {
      this.eventID = this.data.eventId;

      this.getEventByID();
    }
  }

  //#region variables

  eventData = new Cls_EventData();
  eventID: number = 0;
  ErrorMsg: string[] = [];
  isEndDateInvalid: boolean = false;
  minAllowedStartDate = "";
  isStartDateInvalid = false;

  //#endregion

  //#region methods

  getEventByID() {
    this.masterService.getEventByID(this.eventID).subscribe(res => {
      this.eventData = res.data;
      if (this.eventData.StartDate) {
        this.eventData.StartDate = new Date(this.eventData.StartDate).toISOString().split("T")[0];
      }
      if (this.eventData.EndDate) {
        this.eventData.EndDate = new Date(this.eventData.EndDate).toISOString().split("T")[0];
      }
      if (this.eventData.RegistrationLastDate) {
        this.eventData.RegistrationLastDate = new Date(this.eventData.RegistrationLastDate).toISOString().split("T")[0];
      }
    });
  }

  validateStep1(): boolean {
    this.ErrorMsg = [];

    const requiredFields: { key: keyof Cls_EventData; label: string }[] = [
      { key: "EventName", label: "Event Name" },
      { key: "EventDescription", label: "Event Description" },
      { key: "EventType", label: "Event Type" },
      // { key: "MaxParticipants", label: "Students Capacity" },
      // { key: "RegistrationFee", label: "Registration Fee" },
      { key: "RegistrationLastDate", label: "Registration Last Date" },
      { key: "StartDate", label: "Start Date" },
      { key: "EndDate", label: "End Date" },
      { key: "Venue", label: "Venue" },
      { key: "City", label: "City" },
    ];

    for (const field of requiredFields) {
      const value = this.eventData[field.key];
      if (value == null || (typeof value === "string" && !value.trim()) || (Array.isArray(value) && value.length === 0)) {
        this.ErrorMsg.push(`${field.label}`);
      }
    }

    if (this.eventData.StartDate && this.eventData.StartDate < this.minAllowedStartDate) {
      this.ErrorMsg.push("Start date cannot be before the initially selected date");
      this.isStartDateInvalid = true;
    }

    if (this.eventData.StartDate && this.eventData.EndDate && this.eventData.EndDate < this.eventData.StartDate) {
      this.ErrorMsg.push("End date cannot be before start date");
      this.isEndDateInvalid = true;
    }

    const isValid = this.ErrorMsg.length === 0;
    if (!isValid) {
      this.toastService.error("Please fill in all required fields", "Validation Error");
    }
    return isValid;
  }

  onSubmit() {
    if (!this.validateStep1()) {
      return;
    }
    const tempModal = new Cls_EventData();
    tempModal.EventName = this.eventData.EventName;
    tempModal.EventDescription = this.eventData.EventDescription;
    tempModal.EventType = this.eventData.EventType;
    tempModal.StartDate = this.eventData.StartDate;
    tempModal.EndDate = this.eventData.EndDate;
    tempModal.Venue = this.eventData.Venue;
    tempModal.City = this.eventData.City;
    tempModal.MaxParticipants = this.eventData.MaxParticipants;
    tempModal.RegistrationFee = this.eventData.RegistrationFee;
    tempModal.RegistrationLastDate = this.eventData.RegistrationLastDate;
    tempModal.IsActive = this.eventData.IsActive;


    if (this.eventID > 0) {
      this.masterService.updateEvent(tempModal, this.eventID).subscribe(res => {
        this.toastrService.success("Event updated successfully");
        this.dialogRef.close(res);
      });
    } else {
      this.masterService.addEvent(tempModal).subscribe(res => {
        this.toastrService.success("Event added successfully");
        this.dialogRef.close(res);
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  //#endregion
}
